import { useNavigate } from "react-router-dom";
import { useEffect, useCallback, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { completeAuthentication, setAuthenticated, startPeriodicRefresh } from "../../redux";

export default function Home() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const hasCalledAuthentication = useRef(false);

    const authenticateUser = useCallback(async (code) => {
        if (code) {
            try {
                const data = await dispatch(completeAuthentication(code)).unwrap();
                if (data) {
                    dispatch(setAuthenticated());
                    dispatch(startPeriodicRefresh());
                    navigate('/home');
                }
            } catch (error) {
                console.error('❌ Authentication failed:', error);
                hasCalledAuthentication.current = false;
            }
        } else {
            navigate('/login');
        }
    }, [navigate, dispatch]);

    useEffect(() => {
        if (hasCalledAuthentication.current) {
            return;
        }

        const url = new URL(window.location.href);
        const code = url.searchParams.get('code');

        if (code) {
            hasCalledAuthentication.current = true;
            authenticateUser(code);
            return;
        }

        if (isAuthenticated) {
            navigate('/home');
        }
    }, [authenticateUser, isAuthenticated, navigate]);

    return (<></>);
}